import JsonApi from "@/custolink-logic/api/JsonApi";


export enum AdmAssetCmpFormApi$FieldType { "CountrySelect" = "CountrySelect" , "DropdownSelection" = "DropdownSelection" , "EmailField" = "EmailField" , "NumberField" = "NumberField" , "PhoneNumber" = "PhoneNumber" , "RadioSelection" = "RadioSelection" , "TextField" = "TextField"};

export enum AdmSettingsAssetViewsApi$AddViewInputType { "Category" = "Category" , "SnoPatternMatch" = "SnoPatternMatch"};

export enum AdmSupportApi$QueryItemType { "AssetAiConversation" = "AssetAiConversation" , "AssetVideoCall" = "AssetVideoCall" , "Inquiry" = "Inquiry" , "ProductRegistered" = "ProductRegistered" , "VideoCallByLink" = "VideoCallByLink"};

export enum AssetFrontendCmpFormApi$FieldType { "CountrySelect" = "CountrySelect" , "DropdownSelection" = "DropdownSelection" , "EmailField" = "EmailField" , "NumberField" = "NumberField" , "PhoneNumber" = "PhoneNumber" , "RadioSelection" = "RadioSelection" , "TextField" = "TextField"};

export enum AssetFrontendSupportVideoCallsApi$RequestCallResultState { "Active" = "Active" , "Ended" = "Ended" , "Waiting" = "Waiting"};

export enum AssetFrontendViewType { "Category" = "Category" , "Default" = "Default" , "SnoPatternMatch" = "SnoPatternMatch" , "Unknown" = "Unknown"};

export enum AssetFrontendVoiceCallsApi$InfoState { "CallPhoneNumber" = "CallPhoneNumber" , "NotDefined" = "NotDefined" , "ShowText" = "ShowText"};

export enum AssetProtectionBehavior { "HIDE_ASSET" = "HIDE_ASSET" , "HIDE_FILES" = "HIDE_FILES"};

export interface AdmAssetCmpFormApi$EditField {
    assetFrontendSummaryColumn: boolean;
    fieldType: AdmAssetCmpFormApi$FieldType;
    name: string;
    required: boolean;
    selectionOptions: AdmAssetCmpFormApi$EditFieldSelectionOption[];
}

export interface AdmAssetCmpFormApi$EditFieldSelectionOption {
    value: string;
}

export interface AdmAssetCmpFormApi$EditFields {
    fields: AdmAssetCmpFormApi$EditField[];
}

export interface AdmAssetCmpFormApi$Field {
    assetFrontendSummaryColumn: boolean;
    fieldType: AdmAssetCmpFormApi$FieldType;
    name: string;
    required: boolean;
    selectionOptions: string[];
}

export interface AdmAssetCmpFormApi$FieldTypeWrap {
    key: AdmAssetCmpFormApi$FieldType;
    title: string;
}

export interface AdmAssetCmpFormApi$Fields {
    fieldTypes: AdmAssetCmpFormApi$FieldTypeWrap[];
    list: AdmAssetCmpFormApi$Field[];
}

export interface AdmAssetCmpGeneralSettingsApi$GeneralSettings {
    assetProtectionEnabled: boolean;
    behavior: AssetProtectionBehavior;
    defaultModePublic: boolean;
}

export interface AdmSettingsAssetComponentsApi$Component {
    category: string | null;
    conditionsSatisfied: boolean;
    description: string | null;
    filesystemBased: boolean;
    id: number;
    identifier: string;
    name: string;
    tintHex: string | null;
    uiPriority: number;
    visibleInUi: boolean;
}

export interface AdmSettingsAssetComponentsApi$Components {
    keys: string[];
    list: AdmSettingsAssetComponentsApi$Component[];
}

export interface AdmSettingsAssetComponentsApi$EditInput {
    category: string | null;
    description: string | null;
    name: string;
    tintHex: string | null;
    uiPriority: number | null;
    visibleInUi: boolean;
}

export interface AdmSettingsAssetViewsApi$AddViewInput {
    assetForDeriveAttrValsId: number | null;
    attributeName: string;
    multipleAssetsNudge: boolean;
    snoPattern: string;
    snoStripWhitespace: boolean;
    type: AdmSettingsAssetViewsApi$AddViewInputType;
    uiTitle: string;
    urlSlug: string;
}

export interface AdmSettingsAssetViewsApi$AssetViewDto {
    assetForDeriveAttrId: number | null;
    assetForDeriveAttrName: string | null;
    attributeName: string;
    categoryMultipleAssetsNudge: boolean;
    categoryUiTitle: string;
    categoryUrlSlug: string;
    id: number;
    priority: number;
    snoPattern: string;
    snoStripWhitespace: boolean;
    type: AssetFrontendViewType;
}

export interface AdmSettingsAssetViewsApi$AssetViewDtos {
    attrs: AdmSettingsAssetViewsApi$AssetViewDtosAttr[];
    list: AdmSettingsAssetViewsApi$AssetViewDto[];
}

export interface AdmSettingsAssetViewsApi$AssetViewDtosAttr {
    name: string;
}

export interface AdmSettingsAssetViewsApi$EditViewInput {
    assetForDeriveAttrValsId: number | null;
    multipleAssetsNudge: boolean;
    snoPattern: string;
    snoStripWhitespace: boolean;
    uiTitle: string;
    urlSlug: string;
    viewId: number;
}

export interface AdmSupportApi$ConversationDetails {
    startTime: string;
}

export interface AdmSupportApi$ConversationThreadEntry {
    ai: boolean;
    aiError: boolean;
    aiErrorText: string;
    authorUser: string;
    created: string;
    entryText: string;
    id: number;
}

export interface AdmSupportApi$InquiryDetails {
    fieldValues: AdmSupportApi$InquiryDetailsFieldValue[];
}

export interface AdmSupportApi$InquiryDetailsFieldValue {
    field: string;
    value: string;
}

export interface AdmSupportApi$ProductRegistrationDetails {
    fieldValues: AdmSupportApi$RegistrationDetailFieldValue[];
}

export interface AdmSupportApi$QueryItem {
    assetDescription: string;
    closedByDisplayName: string;
    contextUserDisplayName: string;
    contextUserEmail: string;
    contextUserId: number;
    createdDatePretty: string;
    id: number;
    isNew: boolean;
    itemnumber: number;
    sessionTitle: string;
    stateStr: string;
    subject: string;
    type: AdmSupportApi$QueryItemType;
    updatedDatePretty: string;
}

export interface AdmSupportApi$QueryItems {
    items: AdmSupportApi$QueryItem[];
    pageSize: number;
    totalElements: number;
}

export interface AdmSupportApi$QueryItemsInput {
    filterTypes: AdmSupportApi$QueryItemType[];
    page: number;
    pageSize: number;
}

export interface AdmSupportApi$RegistrationDetailFieldValue {
    field: string;
    value: string;
}

export interface AdmSupportApi$SearchItemsInput {
    filterTypes: AdmSupportApi$QueryItemType[];
    page: number;
    pageSize: number;
    searchText: string;
}

export interface AdmSupportApi$VideoCallDetails {
    acceptDatePretty: string;
    callId: number;
    closedByDisplayName: string;
    directInvite: boolean;
    directInviteEmail: string;
    directInvitePhone: string;
    hasSessionMetadata: boolean;
    initedByEnduser: boolean;
    initiatorUserDisplayName: string;
    initiatorUserId: number;
    participants: AdmSupportApi$VideoCallParticipantRow[];
    receiverUserDisplayName: string;
    recordings: VideoCallRecordingSegment[];
    stateStr: string;
}

export interface AdmSupportApi$VideoCallParticipantRow {
    displayName: string;
    joinedPretty: string;
    leftPretty: string;
    role: string;
}

export interface AdmSupportVideoCallSessionApi$AddKeyMomentInput {
    label: string;
}

export interface AdmSupportVideoCallSessionApi$KeyMoment {
    authorDisplayName: string;
    id: number;
    label: string;
    notRecorded: boolean;
    occurredAtEpochMs: number;
    occurredAtPretty: string;
    segmentIndex: number | null;
}

export interface AdmSupportVideoCallSessionApi$RoomSessionInfo {
    activatedAgoMs: number | null;
    assetProductName: string;
    assetViewLabel: string;
    callId: number;
    customerDisplayName: string;
    initedByEnduser: boolean;
    recordingActive: boolean;
    serialNumber: string;
    sessionTitle: string;
    state: string;
}

export interface AdmSupportVideoCallSessionApi$SaveSessionDebriefInput {
    cause: string;
    fix: string;
    nextTechnicianNote: string;
}

export interface AdmSupportVideoCallSessionApi$SaveSessionNoteInput {
    body: string;
    title: string;
}

export interface AdmSupportVideoCallSessionApi$SessionDebrief {
    answered: boolean;
    answeredPretty: string;
    authorDisplayName: string;
    cause: string;
    fix: string;
    nextTechnicianNote: string;
}

export interface AdmSupportVideoCallSessionApi$SessionNote {
    body: string;
    title: string;
    updatedByDisplayName: string;
    updatedPretty: string;
}

export interface AdmSupportVideoCallsApi$CloseCallResult {
    closed: boolean;
    requiresConfirmation: boolean;
}

export interface AdmSupportVideoCallsApi$JoinedSession {
    livekitServerUrl: string;
    livekitToken: string;
    recordingEnabled: boolean;
    roomId: string;
    userDisplayName: string;
    workerIdentity: string;
}

export interface AdmSupportVideoCallsApi$LiveSession {
    callId: number;
    counterpartDisplayName: string;
    createdPretty: string;
    customerPresent: boolean;
    initedByEnduser: boolean;
    onlyWorkerIsMe: boolean;
    participantCount: number;
    recordingActive: boolean;
    roomId: string;
    state: string;
    workerPresent: boolean;
}

export interface AdmVideoCallByLinkApi$CreateDirectInviteVideoCallInput {
    email: string;
    name: string;
    phone: string;
    record: boolean;
}

export interface AdmVideoCallByLinkApi$CreateVideoCallInput {
    phone: string;
    receiverUserId: number;
    record: boolean;
    savePhoneOnUser: boolean;
}

export interface AdmVideoCallByLinkApi$CreateVideoCallResult {
    callId: number;
    livekitServerUrl: string;
    livekitToken: string;
    recordingEnabled: boolean;
    roomId: string;
}

export interface AdmVoiceCallCmpAdmApi$SetVoiceCallInfo {
    call_phone_method: boolean;
    phone: string;
    text: string;
}

export interface AdmVoiceCallCmpAdmApi$VoiceCallInfo {
    call_phone_method: boolean;
    phone: string;
    text: string;
}

export interface AssetFrontendCmpFormApi$FormField {
    fieldType: AssetFrontendCmpFormApi$FieldType;
    i18nNameKey: string | null;
    name: string;
    required: boolean;
    selectionOptions: string[];
}

export interface AssetFrontendCmpFormApi$FormFields {
    fields: AssetFrontendCmpFormApi$FormField[];
    i18nprefix: string;
}

export interface AssetFrontendCmpFormApi$FormInput {
    values: AssetFrontendCmpFormApi$FormInputValue[];
}

export interface AssetFrontendCmpFormApi$FormInputValue {
    value: string;
}

export interface AssetFrontendCmpInquiryApi$CurrentEnquiriesResult {
    enquiries: AssetFrontendCmpInquiryApi$CurrentInquiry[];
}

export interface AssetFrontendCmpInquiryApi$CurrentInquiry {
    createdPrettyDate: string;
    id: number;
    summary: string;
    values: AssetFrontendCmpInquiryApi$CurrentInquiryValue[];
}

export interface AssetFrontendCmpInquiryApi$CurrentInquiryValue {
    name: string;
    value: string;
}

export interface AssetFrontendCmpRegisterProductApi$GetInfo {
    alreadyRegisteredByThisUser: boolean;
}

export interface AssetFrontendSupportLangflowAiApi$ContextFile {
    fileId: number;
    filename: string;
    pages: string;
}

export interface AssetFrontendSupportLangflowAiApi$Input {
    query: string;
}

export interface AssetFrontendSupportLangflowAiApi$Result {
    contextFile: AssetFrontendSupportLangflowAiApi$ContextFile[];
    response: string;
}

export interface AssetFrontendSupportVideoCallsApi$RequestCallResult {
    livekitServerUrl: string | null;
    livekitToken: string | null;
    recordingEnabled: boolean;
    roomId: string;
    state: AssetFrontendSupportVideoCallsApi$RequestCallResultState;
    userDisplayName: string;
}

export interface AssetFrontendVoiceCallsApi$Info {
    phone: string;
    state: AssetFrontendVoiceCallsApi$InfoState;
    text: string;
}

export interface ContentSearchHitView {
    knowledgePublished: boolean;
    knowledgeVersionNumber: number | null;
    offsetMs: number | null;
    recordingId: number | null;
    refId: number;
    segmentIndex: number | null;
    snippet: string;
    source: string;
    speaker: string;
}

export interface ContentSearchInput {
    searchText: string;
}

export interface ContentSearchResultView {
    sessions: ContentSearchSessionView[];
    truncated: boolean;
}

export interface ContentSearchSessionView {
    assetProductName: string;
    callId: number;
    customerDisplayName: string;
    hits: ContentSearchHitView[];
    itemnumber: number;
    serialNumber: string;
    sessionAtEpochMs: number;
    sessionTitle: string;
    supportItemId: number;
}

export interface KnowledgeEvidenceInput {
    kind: string;
    lineId: number | null;
    snapshotUuid: string | null;
}

export interface KnowledgeEvidenceView {
    available: boolean;
    evidenceId: number;
    excerpt: string;
    kind: string;
    lineId: number | null;
    offsetMs: number | null;
    recordingId: number | null;
    segmentIndex: number | null;
    snapshotUuid: string | null;
    speaker: string;
    speakerRole: string;
}

export interface KnowledgeRecordView {
    aiIndexState: string;
    current: KnowledgeVersionView | null;
    draftingConfigured: boolean;
    enabled: boolean;
    evidenceMaterialAvailable: boolean;
    exists: boolean;
    generationError: string | null;
    generationRequestedAtEpochMs: number | null;
    generationStatus: string;
    latestVersionNumber: number | null;
    mayPublish: boolean;
    publishBlockedReason: string | null;
    publishedAtEpochMs: number | null;
    publishedByDisplayName: string;
    publishedFileMissing: boolean;
    publishedFilePath: string;
    publishedVersionNumber: number | null;
    sessionEnded: boolean;
    versions: KnowledgeVersionSummaryView[];
}

export interface KnowledgeStatementInput {
    certainty: string;
    evidence: KnowledgeEvidenceInput[];
    kind: string;
    sourceStatementId: number | null;
    text: string;
}

export interface KnowledgeStatementView {
    certainty: string;
    certaintyDowngraded: boolean;
    evidence: KnowledgeEvidenceView[];
    kind: string;
    origin: string;
    position: number;
    statementId: number;
    text: string;
}

export interface KnowledgeVersionSummaryView {
    basedOnVersionNumber: number | null;
    createdAtEpochMs: number;
    createdByDisplayName: string;
    origin: string;
    previouslyPublished: boolean;
    published: boolean;
    statementCount: number;
    versionNumber: number;
}

export interface KnowledgeVersionView {
    basedOnVersionNumber: number | null;
    createdAtEpochMs: number;
    createdByDisplayName: string;
    origin: string;
    promptVersion: string | null;
    published: boolean;
    statements: KnowledgeStatementView[];
    title: string;
    versionNumber: number;
}

export interface RecordingStatusView {
    acceptedIdentities: string[];
    pendingIdentities: string[];
    phase: string;
    recordingSinceEpochMs: number | null;
    refusedIdentities: string[];
    requested: boolean;
    segmentIndex: number | null;
}

export interface RecordingTimelineEvent {
    atEpochMs: number;
    kind: string;
    label: string;
    offsetMs: number | null;
    recorded: boolean;
    recordingId: number | null;
    refId: string;
    segmentIndex: number | null;
}

export interface RecordingTimelineSegment {
    recordedFromEpochMs: number | null;
    recordedToEpochMs: number | null;
    recordingId: number;
    segmentIndex: number;
    state: string;
}

export interface RecordingTimelineView {
    events: RecordingTimelineEvent[];
    segments: RecordingTimelineSegment[];
}

export interface SaveKnowledgeVersionInput {
    basedOnVersionNumber: number;
    statements: KnowledgeStatementInput[];
    title: string;
}

export interface SessionMetadataDeletionResult {
    consentAnswersDeleted: number;
    debriefDeleted: number;
    framesDeleted: number;
    momentsDeleted: number;
    noteDeleted: number;
    opsDeleted: number;
    participantsDeleted: number;
    snapshotsDeleted: number;
}

export interface SyncActiveSource {
    identity: string;
    trackSid: string;
}

export interface SyncActiveSourceInput {
    identity: string;
    trackSid: string;
}

export interface SyncFrameDescriptor {
    capturedAtEpochMs: number;
    frameId: string;
    mirrored: boolean;
    rotation: number;
    sourceH: number;
    sourceId: string;
    sourceIdentity: string;
    sourceW: number;
}

export interface SyncFreezeRequest {
    frameId: string;
    identity: string;
    requestedAtEpochMs: number;
    trackSid: string;
}

export interface SyncOpAccepted {
    duplicate: boolean;
    opId: string;
    seq: number;
}

export interface SyncOpInput {
    frameId: string;
    kind: string;
    opId: string;
    payload: string;
    redoOf: string | null;
    undoOf: string | null;
}

export interface SyncOpView {
    authorIdentity: string;
    createdAtEpochMs: number;
    frameId: string;
    kind: string;
    opId: string;
    payload: string;
    redoOf: string | null;
    seq: number;
    undoOf: string | null;
}

export interface SyncRoomStateView {
    activeFrame: SyncFrameDescriptor | null;
    activeSource: SyncActiveSource | null;
    customerMayAnnotate: boolean;
    freezeRequest: SyncFreezeRequest | null;
    hasMoreOps: boolean;
    latestSeq: number;
    ops: SyncOpView[];
    recording: RecordingStatusView;
    stateVersion: number;
}

export interface SyncSnapshotView {
    createdAtEpochMs: number;
    frameId: string;
    opCount: number;
    snapshotId: string;
    upToSeq: number;
}

export interface TranscriptReadModel$FlaggedWordView {
    confidence: number | null;
    text: string;
}

export interface TranscriptReadModel$SegmentTranscriptView {
    canTranscribeAgain: boolean;
    detectedLanguages: string[];
    failedSpeakers: string[];
    failureReason: string | null;
    lines: TranscriptReadModel$TranscriptLineView[];
    recordingId: number;
    recordingState: string;
    segmentIndex: number;
    transcriptState: string;
}

export interface TranscriptReadModel$SessionTranscriptView {
    availability: TranscriptionAvailabilityView;
    segments: TranscriptReadModel$SegmentTranscriptView[];
}

export interface TranscriptReadModel$TranscriptLineView {
    confidence: number | null;
    editVersion: number;
    edited: boolean;
    editedAtEpochMs: number | null;
    editedByName: string | null;
    endMs: number | null;
    flaggedWords: TranscriptReadModel$FlaggedWordView[];
    id: number;
    language: string | null;
    lowConfidence: boolean;
    offsetMs: number;
    originalText: string;
    recordingId: number;
    segmentIndex: number;
    speakerLabel: string | null;
    text: string;
}

export interface TranscriptionAvailabilityView {
    available: boolean;
    reason: string | null;
}

export interface TranscriptionUsecases$EditTranscriptLineInput {
    editVersion: number;
    text: string;
}

export interface VideoCallRecordingSegment {
    available: boolean;
    durationPretty: string;
    recordingId: number;
    segmentIndex: number;
    sizePretty: string;
    state: string;
}
export enum PublicAssetFrontendApi$AssetComponentDtoKey { "AiSupport" = "AiSupport" , "Certificates" = "Certificates" , "Drawings" = "Drawings" , "Inquiry" = "Inquiry" , "Manuals" = "Manuals" , "QuickStartGuides" = "QuickStartGuides" , "RegisterProduct" = "RegisterProduct" , "SafetyVideos" = "SafetyVideos" , "TrainingVideos" = "TrainingVideos" , "VideoCall" = "VideoCall" , "VoiceCall" = "VoiceCall"};

export interface PublicAssetFrontendApi$AssetComponentDto {
    description: string | null;
    filesystemComponent: boolean;
    i18nNameKey: string | null;
    id: number;
    key: PublicAssetFrontendApi$AssetComponentDtoKey;
    name: string;
    tintHex: string | null;
    uiPriority: number;
}

export interface PublicAssetFrontendApi$AssetComponents {
    bottomSection: PublicAssetFrontendApi$AssetComponentDto[];
    middleSection: PublicAssetFrontendApi$AssetComponentDto[];
    topSection: PublicAssetFrontendApi$AssetComponentDto[];
}

export interface PublicAssetFrontendApi$GetComponents {
    components: PublicAssetFrontendApi$AssetComponents;
}

export interface PublicAssetFrontendApi$InferredDefaultViewInfo {
    serialNumber: string;
}

export interface PublicAssetFrontendApi$InferredViewByCategory {
    uiNudgeToInputSerial: boolean;
    uiSlug: string;
    uiTitle: string;
    viewValue: string;
}

export interface PublicAssetFrontendApi$InferredViewBySerialnumberPatternMatch {
    serialNumber: string;
}

export interface PublicAssetFrontendApi$ViewDetails {
    assetId: number;
    assetProductName: string;
    components: PublicAssetFrontendApi$AssetComponents;
    id: number;
    inferredCategoryView: PublicAssetFrontendApi$InferredViewByCategory | null;
    inferredDefaultView: PublicAssetFrontendApi$InferredDefaultViewInfo | null;
    inferredSerialnumberPatternMatchView: PublicAssetFrontendApi$InferredViewBySerialnumberPatternMatch | null;
    protectedSignInRequired: boolean;
}

export interface PublicAssetFrontendUserApi$SignInCodeCheck {
    code: string;
    email: string;
}

export interface PublicAssetFrontendUserApi$SignInCodeCheckResult {
    errorMessage: string;
    success: boolean;
}

export interface PublicAssetFrontendUserApi$SigninValidateEmail {
    email: string;
}

export interface PublicAssetFrontendUserApi$SigninWithPassword {
    email: string;
    password: string;
}

export interface PublicAssetFrontendUserApi$Signup {
    email: string;
    name: string;
    password: string;
}

export interface PublicSupportVideoCallsApi$EnduserInstantvideolinkStatusResult {
    closed: boolean;
}

export interface PublicSupportVideoCallsApi$EnduserRespondResult {
    callerDisplayName: string;
    livekitServerUrl: string;
    livekitToken: string;
    organisationName: string;
    recordingEnabled: boolean;
    userDisplayName: string;
}

export interface RecordingStatusView {
    acceptedIdentities: string[];
    pendingIdentities: string[];
    phase: string;
    recordingSinceEpochMs: number | null;
    refusedIdentities: string[];
    requested: boolean;
    segmentIndex: number | null;
}

export interface SyncActiveSource {
    identity: string;
    trackSid: string;
}

export interface SyncFrameDescriptor {
    capturedAtEpochMs: number;
    frameId: string;
    mirrored: boolean;
    rotation: number;
    sourceH: number;
    sourceId: string;
    sourceIdentity: string;
    sourceW: number;
}

export interface SyncFreezeRequest {
    frameId: string;
    identity: string;
    requestedAtEpochMs: number;
    trackSid: string;
}

export interface SyncOpAccepted {
    duplicate: boolean;
    opId: string;
    seq: number;
}

export interface SyncOpInput {
    frameId: string;
    kind: string;
    opId: string;
    payload: string;
    redoOf: string | null;
    undoOf: string | null;
}

export interface SyncOpView {
    authorIdentity: string;
    createdAtEpochMs: number;
    frameId: string;
    kind: string;
    opId: string;
    payload: string;
    redoOf: string | null;
    seq: number;
    undoOf: string | null;
}

export interface SyncRoomStateView {
    activeFrame: SyncFrameDescriptor | null;
    activeSource: SyncActiveSource | null;
    customerMayAnnotate: boolean;
    freezeRequest: SyncFreezeRequest | null;
    hasMoreOps: boolean;
    latestSeq: number;
    ops: SyncOpView[];
    recording: RecordingStatusView;
    stateVersion: number;
}
export const AdmAssetCmpFormApi = {
  getFields: (orgId:number,componentId:number) : Promise<AdmAssetCmpFormApi$Fields> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/asset_component/form/" + componentId + "/fields")
  },
  setFields: (orgId:number,componentId:number,input:AdmAssetCmpFormApi$EditFields) : Promise<void> => {
    return JsonApi.put("api/admin/bc/asset_interaction/organisation/" + orgId + "/asset_component/form/" + componentId + "/fields",input)
  },
}
export const AdmAssetCmpGeneralSettingsApi = {
  get: (orgId:number) : Promise<AdmAssetCmpGeneralSettingsApi$GeneralSettings> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/asset_component/general_settings")
  },
  set: (orgId:number,input:AdmAssetCmpGeneralSettingsApi$GeneralSettings) : Promise<void> => {
    return JsonApi.put("api/admin/bc/asset_interaction/organisation/" + orgId + "/asset_component/general_settings",input)
  },
}
export const AdmAssetIntActOrgQrApi = {
  downloadBrandedPng: (orgId:number) : Promise<unknown> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/asset_interaction/org_qr/qr/branded/png")
  },
  getQrPng: (orgId:number) : Promise<unknown> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/asset_interaction/org_qr/qr/png")
  },
}
export const AdmSettingsAssetComponentsApi = {
  editComponent: (orgId:number,componentId:number,input:AdmSettingsAssetComponentsApi$EditInput) : Promise<string> => {
    return JsonApi.put("api/admin/bc/asset_interaction/" + orgId + "/settings/assets/components/edit/" + componentId + "",input)
  },
  get: (orgId:number) : Promise<AdmSettingsAssetComponentsApi$Components> => {
    return JsonApi.get("api/admin/bc/asset_interaction/" + orgId + "/settings/assets/components")
  },
}
export const AdmSettingsAssetViewsApi = {
  addCategoryBasedView: (orgId:number,input:AdmSettingsAssetViewsApi$AddViewInput) : Promise<void> => {
    return JsonApi.post("api/admin/organisation/" + orgId + "/settings/assets/views/add_category_based_view",input)
  },
  addSnoPatternMatchBasedView: (orgId:number,input:AdmSettingsAssetViewsApi$AddViewInput) : Promise<void> => {
    return JsonApi.post("api/admin/organisation/" + orgId + "/settings/assets/views/add_sno_pattern_match_view",input)
  },
  deleteView: (orgId:number,viewId:number) : Promise<void> => {
    return JsonApi.del("api/admin/organisation/" + orgId + "/settings/assets/views/delete_view?viewId="+ ( viewId == null ? "" : viewId ) +"")
  },
  editView: (orgId:number,input:AdmSettingsAssetViewsApi$EditViewInput) : Promise<void> => {
    return JsonApi.put("api/admin/organisation/" + orgId + "/settings/assets/views/edit_view",input)
  },
  get: (orgId:number) : Promise<AdmSettingsAssetViewsApi$AssetViewDtos> => {
    return JsonApi.get("api/admin/organisation/" + orgId + "/settings/assets/views")
  },
}
export const AdmSupportApi = {
  getConversationDetails: (orgId:number,supportItemId:number) : Promise<AdmSupportApi$ConversationDetails> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/details/" + supportItemId + "/conversation")
  },
  getConversationThread: (orgId:number,supportItemId:number) : Promise<Array<AdmSupportApi$ConversationThreadEntry>> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/details/" + supportItemId + "/conversation/thread")
  },
  getInquiryDetails: (orgId:number,supportItemId:number) : Promise<AdmSupportApi$InquiryDetails> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/details/" + supportItemId + "/inquiry")
  },
  getProductRegistrationDetails: (orgId:number,supportItemId:number) : Promise<AdmSupportApi$ProductRegistrationDetails> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/details/" + supportItemId + "/product_registration")
  },
  getVideoCallDetails: (orgId:number,supportItemId:number) : Promise<AdmSupportApi$VideoCallDetails> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/details/" + supportItemId + "/videocall")
  },
  markAsRead: (orgId:number,supportItemId:number) : Promise<void> => {
    return JsonApi.put("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/mark_as_read/" + supportItemId + "")
  },
  queryItems: (orgId:number,input:AdmSupportApi$QueryItemsInput) : Promise<AdmSupportApi$QueryItems> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/query_items",input)
  },
  searchItems: (orgId:number,input:AdmSupportApi$SearchItemsInput) : Promise<AdmSupportApi$QueryItems> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/search_items",input)
  },
}
export const AdmSupportContentSearchApi = {
  searchSessionContent: (orgId:number,input:ContentSearchInput) : Promise<ContentSearchResultView> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/content_search",input)
  },
}
export const AdmSupportVideoCallKnowledgeApi = {
  generateKnowledgeDraft: (orgId:number,callId:number) : Promise<KnowledgeRecordView> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/knowledge_record/generate")
  },
  getKnowledgeRecord: (orgId:number,callId:number) : Promise<KnowledgeRecordView> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/knowledge_record")
  },
  getKnowledgeRecordVersion: (orgId:number,callId:number,versionNumber:number) : Promise<KnowledgeVersionView> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/knowledge_record/versions/" + versionNumber + "")
  },
  publishKnowledgeRecordVersion: (orgId:number,callId:number,versionNumber:number) : Promise<KnowledgeRecordView> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/knowledge_record/versions/" + versionNumber + "/publish")
  },
  saveKnowledgeRecordVersion: (orgId:number,callId:number,input:SaveKnowledgeVersionInput) : Promise<KnowledgeRecordView> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/knowledge_record/versions",input)
  },
  unpublishKnowledgeRecord: (orgId:number,callId:number) : Promise<KnowledgeRecordView> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/knowledge_record/unpublish")
  },
}
export const AdmSupportVideoCallRecordingApi = {
  deleteRecording: (orgId:number,callId:number,recordingId:number) : Promise<void> => {
    return JsonApi.del("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/calls/" + callId + "/recordings/" + recordingId + "")
  },
  listRecordings: (orgId:number,callId:number) : Promise<Array<VideoCallRecordingSegment>> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/calls/" + callId + "/recordings")
  },
}
export const AdmSupportVideoCallRecordingConsentApi = {
  decideRecordingConsent: (orgId:number,callId:number,accepted:boolean) : Promise<RecordingStatusView> => {
    return JsonApi.put("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/recording/consent?accepted="+ ( accepted == null ? "" : accepted ) +"")
  },
  getRecordingStatus: (orgId:number,callId:number) : Promise<RecordingStatusView> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/recording/status")
  },
}
export const AdmSupportVideoCallSessionApi = {
  addMoment: (orgId:number,callId:number,input:AdmSupportVideoCallSessionApi$AddKeyMomentInput) : Promise<AdmSupportVideoCallSessionApi$KeyMoment> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/moments",input)
  },
  getDebrief: (orgId:number,callId:number) : Promise<AdmSupportVideoCallSessionApi$SessionDebrief> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/debrief")
  },
  getMoments: (orgId:number,callId:number) : Promise<Array<AdmSupportVideoCallSessionApi$KeyMoment>> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/moments")
  },
  getNotes: (orgId:number,callId:number) : Promise<AdmSupportVideoCallSessionApi$SessionNote> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/notes")
  },
  getRoomInfo: (orgId:number,callId:number) : Promise<AdmSupportVideoCallSessionApi$RoomSessionInfo> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/room_info")
  },
  saveDebrief: (orgId:number,callId:number,input:AdmSupportVideoCallSessionApi$SaveSessionDebriefInput) : Promise<AdmSupportVideoCallSessionApi$SessionDebrief> => {
    return JsonApi.put("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/debrief",input)
  },
  saveNotes: (orgId:number,callId:number,input:AdmSupportVideoCallSessionApi$SaveSessionNoteInput) : Promise<AdmSupportVideoCallSessionApi$SessionNote> => {
    return JsonApi.put("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/notes",input)
  },
}
export const AdmSupportVideoCallSessionDataApi = {
  deleteSessionMetadata: (orgId:number,callId:number) : Promise<SessionMetadataDeletionResult> => {
    return JsonApi.del("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/session_metadata")
  },
  getRecordingTimeline: (orgId:number,callId:number) : Promise<RecordingTimelineView> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/recording_timeline")
  },
}
export const AdmSupportVideoCallSyncApi = {
  appendOp: (orgId:number,callId:number,input:SyncOpInput) : Promise<SyncOpAccepted> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/sync/ops",input)
  },
  getRoomState: (orgId:number,callId:number,sinceSeq:number) : Promise<SyncRoomStateView> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/sync/room_state?sinceSeq="+ ( sinceSeq == null ? "" : sinceSeq ) +"")
  },
  requestFreeze: (orgId:number,callId:number,input:SyncActiveSourceInput) : Promise<SyncRoomStateView> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/sync/freeze_request",input)
  },
  resumeLive: (orgId:number,callId:number) : Promise<SyncRoomStateView> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/sync/resume_live")
  },
  saveSnapshot: (orgId:number,callId:number,frameId:string,upToSeq:number,file:File) : Promise<SyncSnapshotView> => {
    return JsonApi.post_form("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/sync/snapshots",{"frameId": frameId,"upToSeq": upToSeq,"file": file})
  },
  setActiveSource: (orgId:number,callId:number,input:SyncActiveSourceInput) : Promise<SyncRoomStateView> => {
    return JsonApi.put("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/sync/active_source",input)
  },
  setAnnotationPermission: (orgId:number,callId:number,granted:boolean) : Promise<SyncRoomStateView> => {
    return JsonApi.put("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/sync/annotation_permission?granted="+ ( granted == null ? "" : granted ) +"")
  },
  uploadFrame: (orgId:number,callId:number,frameId:string,trackSid:string,width:number,height:number,mirrored:boolean,rotation:number,capturedAtEpochMs:number,file:File) : Promise<SyncFrameDescriptor> => {
    return JsonApi.post_form("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/sync/frames",{"frameId": frameId,"trackSid": trackSid,"width": width,"height": height,"mirrored": mirrored,"rotation": rotation,"capturedAtEpochMs": capturedAtEpochMs,"file": file})
  },
}
export const AdmSupportVideoCallTranscriptApi = {
  editLine: (orgId:number,callId:number,lineId:number,input:TranscriptionUsecases$EditTranscriptLineInput) : Promise<TranscriptReadModel$TranscriptLineView> => {
    return JsonApi.put("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/transcript/lines/" + lineId + "",input)
  },
  getTranscript: (orgId:number,callId:number) : Promise<TranscriptReadModel$SessionTranscriptView> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/transcript")
  },
  transcribeAgain: (orgId:number,callId:number,recordingId:number) : Promise<TranscriptReadModel$SessionTranscriptView> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/transcript/segments/" + recordingId + "/transcribe_again")
  },
}
export const AdmSupportVideoCallsApi = {
  closeCall: (orgId:number,callId:number,confirmed:boolean,fromRoom:boolean) : Promise<AdmSupportVideoCallsApi$CloseCallResult> => {
    return JsonApi.put("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/close?confirmed="+ ( confirmed == null ? "" : confirmed ) +"&fromRoom="+ ( fromRoom == null ? "" : fromRoom ) +"")
  },
  getLiveSessions: (orgId:number) : Promise<Array<AdmSupportVideoCallsApi$LiveSession>> => {
    return JsonApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/live_sessions")
  },
  joinCall: (orgId:number,callId:number) : Promise<AdmSupportVideoCallsApi$JoinedSession> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/join")
  },
}
export const AdmVideoCallByLinkApi = {
  createDirectInviteVideoCall: (orgId:number,input:AdmVideoCallByLinkApi$CreateDirectInviteVideoCallInput) : Promise<AdmVideoCallByLinkApi$CreateVideoCallResult> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video_call_by_link/create_direct_invite_video_call",input)
  },
  createVideoCall: (orgId:number,createVideoCallInput:AdmVideoCallByLinkApi$CreateVideoCallInput) : Promise<AdmVideoCallByLinkApi$CreateVideoCallResult> => {
    return JsonApi.post("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video_call_by_link/create_video_call",createVideoCallInput)
  },
}
export const AdmVoiceCallCmpAdmApi = {
  getInfo: (orgId:number,componentId:number) : Promise<AdmVoiceCallCmpAdmApi$VoiceCallInfo> => {
    return JsonApi.get("api/admin/bc/asset_files/" + orgId + "/asset_component/voice_call/" + componentId + "")
  },
  setInfo: (orgId:number,componentId:number,payload:AdmVoiceCallCmpAdmApi$SetVoiceCallInfo) : Promise<void> => {
    return JsonApi.put("api/admin/bc/asset_files/" + orgId + "/asset_component/voice_call/" + componentId + "",payload)
  },
}
export const AssetFrontendCmpFormApi = {
  getCustomfields: (orgId:number,componentId:number) : Promise<AssetFrontendCmpFormApi$FormFields> => {
    return JsonApi.get("api/asset_frontend/bc/asset_interaction/" + orgId + "/component/customfields/customfields/" + componentId + "")
  },
  submitCustomfieldsForAssetView: (orgId:number,componentId:number,viewId:number,viewValue:string,assetId:number,input:AssetFrontendCmpFormApi$FormInput) : Promise<void> => {
    return JsonApi.post("api/asset_frontend/bc/asset_interaction/" + orgId + "/component/customfields/customfields/" + componentId + "/submit_for_asset_view?viewId="+ ( viewId == null ? "" : viewId ) +"&viewValue="+ ( viewValue == null ? "" : viewValue ) +"&assetId="+ ( assetId == null ? "" : assetId ) +"",input)
  },
}
export const AssetFrontendCmpInquiryApi = {
  getCurrentEnquiries: (orgId:number,ViewId:number,ViewValue:string,assetId:number) : Promise<AssetFrontendCmpInquiryApi$CurrentEnquiriesResult> => {
    return JsonApi.get("api/asset_frontend/bc/asset_interaction/" + orgId + "/component/inquiry/current?ViewId="+ ( ViewId == null ? "" : ViewId ) +"&ViewValue="+ ( ViewValue == null ? "" : ViewValue ) +"&assetId="+ ( assetId == null ? "" : assetId ) +"")
  },
}
export const AssetFrontendCmpRegisterProductApi = {
  getInfo: (orgId:number,viewId:number,viewValue:string,assetId:number) : Promise<AssetFrontendCmpRegisterProductApi$GetInfo> => {
    return JsonApi.get("api/asset_frontend/bc/asset_interaction/" + orgId + "/component/register_product/info?viewId="+ ( viewId == null ? "" : viewId ) +"&viewValue="+ ( viewValue == null ? "" : viewValue ) +"&assetId="+ ( assetId == null ? "" : assetId ) +"")
  },
}
export const AssetFrontendSupportLangflowAiApi = {
  chatPrompt: (orgId:number,viewId:number,viewValue:string,assetId:number,input:AssetFrontendSupportLangflowAiApi$Input) : Promise<AssetFrontendSupportLangflowAiApi$Result> => {
    return JsonApi.post("api/asset_frontend/bc/asset_interaction/" + orgId + "/support/ai/langflow/chat/prompt?viewId="+ ( viewId == null ? "" : viewId ) +"&viewValue="+ ( viewValue == null ? "" : viewValue ) +"&assetId="+ ( assetId == null ? "" : assetId ) +"",input)
  },
  chatPromptStream: (orgId:number,viewId:number,viewValue:string,assetId:number,input:AssetFrontendSupportLangflowAiApi$Input) : Promise<Response> => {
    return JsonApi.fetchStream("api/asset_frontend/bc/asset_interaction/" + orgId + "/support/ai/langflow/chat/prompt/stream?viewId="+ ( viewId == null ? "" : viewId ) +"&viewValue="+ ( viewValue == null ? "" : viewValue ) +"&assetId="+ ( assetId == null ? "" : assetId ) +"",input)
  },
}
export const AssetFrontendSupportVideoCallsApi = {
  closeCallIfPending: (orgId:number) : Promise<void> => {
    return JsonApi.get("api/asset_frontend/bc/asset_interaction/org/" + orgId + "/support/video_calls/close_call_if_pending")
  },
  queryPending: (orgId:number) : Promise<AssetFrontendSupportVideoCallsApi$RequestCallResult> => {
    return JsonApi.get("api/asset_frontend/bc/asset_interaction/org/" + orgId + "/support/video_calls/call_state")
  },
  requestCall: (orgId:number,viewId:number,viewValue:string,assetId:number) : Promise<AssetFrontendSupportVideoCallsApi$RequestCallResult> => {
    return JsonApi.post("api/asset_frontend/bc/asset_interaction/org/" + orgId + "/support/video_calls/request_call?viewId="+ ( viewId == null ? "" : viewId ) +"&viewValue="+ ( viewValue == null ? "" : viewValue ) +"&assetId="+ ( assetId == null ? "" : assetId ) +"")
  },
}
export const AssetFrontendVoiceCallsApi = {
  getInfo: (orgId:number,componentId:number) : Promise<AssetFrontendVoiceCallsApi$Info> => {
    return JsonApi.get("public-api/asset_frontend/bc/asset_interaction/" + orgId + "/support/voice_calls/" + componentId + "/info")
  },
}

export const PublicAssetFrontendApi = {
  getComponents: (organisationId:number) : Promise<PublicAssetFrontendApi$GetComponents> => {
    return JsonApi.get("public-api/asset_frontend/bc/asset_frontend/" + organisationId + "/components")
  },
  getViewDetails: (organisationId:number,serialNumber:string,viewUiSlug:string,viewAttrValue:string) : Promise<PublicAssetFrontendApi$ViewDetails> => {
    return JsonApi.get("public-api/asset_frontend/bc/asset_frontend/" + organisationId + "?serialNumber="+ ( serialNumber == null ? "" : serialNumber ) +"&viewUiSlug="+ ( viewUiSlug == null ? "" : viewUiSlug ) +"&viewAttrValue="+ ( viewAttrValue == null ? "" : viewAttrValue ) +"")
  },
}
export const PublicAssetFrontendUserApi = {
  signinValidateEmail: (orgId:number,dto:PublicAssetFrontendUserApi$SigninValidateEmail) : Promise<void> => {
    return JsonApi.post("public-api/asset_frontend/bc/asset_interaction/" + orgId + "/user/signinValidateEmail",dto)
  },
  signinWithCodeCheck: (orgId:number,signInCodeCheck:PublicAssetFrontendUserApi$SignInCodeCheck) : Promise<PublicAssetFrontendUserApi$SignInCodeCheckResult> => {
    return JsonApi.post("public-api/asset_frontend/bc/asset_interaction/" + orgId + "/user/signin_with_code_check",signInCodeCheck)
  },
  signinWithCodeRequest: (orgId:number,email:string) : Promise<void> => {
    return JsonApi.post("public-api/asset_frontend/bc/asset_interaction/" + orgId + "/user/signin_with_code_request?email="+ ( email == null ? "" : email ) +"")
  },
  signinWithPassword: (orgId:number,dto:PublicAssetFrontendUserApi$SigninWithPassword) : Promise<void> => {
    return JsonApi.post("public-api/asset_frontend/bc/asset_interaction/" + orgId + "/user/signin_with_password",dto)
  },
  signup: (orgId:number,input:PublicAssetFrontendUserApi$Signup) : Promise<void> => {
    return JsonApi.post("public-api/asset_frontend/bc/asset_interaction/" + orgId + "/user/create_account",input)
  },
}
export const PublicSupportVideoCallRecordingConsentApi = {
  enduserDecideRecordingConsent: (roomId:string,accepted:boolean) : Promise<RecordingStatusView> => {
    return JsonApi.put("public-api/support/videocalls/enduser/recording/" + roomId + "/consent?accepted="+ ( accepted == null ? "" : accepted ) +"")
  },
  enduserGetRecordingStatus: (roomId:string) : Promise<RecordingStatusView> => {
    return JsonApi.get("public-api/support/videocalls/enduser/recording/" + roomId + "/status")
  },
}
export const PublicSupportVideoCallSyncApi = {
  enduserAppendOp: (roomId:string,input:SyncOpInput) : Promise<SyncOpAccepted> => {
    return JsonApi.post("public-api/support/videocalls/enduser/sync/" + roomId + "/ops",input)
  },
  enduserGetRoomState: (roomId:string,sinceSeq:number) : Promise<SyncRoomStateView> => {
    return JsonApi.get("public-api/support/videocalls/enduser/sync/" + roomId + "/room_state?sinceSeq="+ ( sinceSeq == null ? "" : sinceSeq ) +"")
  },
  enduserUploadFrame: (roomId:string,frameId:string,trackSid:string,width:number,height:number,mirrored:boolean,rotation:number,capturedAtEpochMs:number,file:File) : Promise<SyncFrameDescriptor> => {
    return JsonApi.post_form("public-api/support/videocalls/enduser/sync/" + roomId + "/frames",{"frameId": frameId,"trackSid": trackSid,"width": width,"height": height,"mirrored": mirrored,"rotation": rotation,"capturedAtEpochMs": capturedAtEpochMs,"file": file})
  },
}
export const PublicSupportVideoCallsApi = {
  enduserInstantVideolinkStatus: (roomId:string) : Promise<PublicSupportVideoCallsApi$EnduserInstantvideolinkStatusResult> => {
    return JsonApi.get("public-api/support/videocalls/enduser/instantvideolink/status/" + roomId + "")
  },
  enduserJoinInstantvideolink: (roomId:string) : Promise<PublicSupportVideoCallsApi$EnduserRespondResult> => {
    return JsonApi.get("public-api/support/videocalls/enduser/instantvideolink/join/" + roomId + "")
  },
}
